import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';

export const authGuard: CanActivateFn =
  (_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree => {

    const auth = inject(AuthService);
    const router = inject(Router);

    if (auth.isTokenValid()) {
      // Token OK. Limpa qualquer redirect antigo
      auth.clearRedirect();
      return true;
    }
    // Token ausente/expirado. Salva a rota solicitada e manda p/ login
    auth.saveRedirect(state.url);
    return router.parseUrl('/login');
  };


